// extracted by mini-css-extract-plugin
module.exports = {"input":"Checkbox_input__JC9f1","target":"Checkbox_target__17QsW","target--checked":"Checkbox_target--checked__2OHfS"};